import styled from 'styled-components'

export const StyledContainer = styled.div`
  &.editable {
    svg {
      cursor: pointer;
    }
  }
  svg {
    & + svg {
      margin-left: 2px;
    }
  }
`
